import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import { VERIFY_EMAIL_INVALID_TOKEN } from './types';

const invalidTokenVerifyEmail = createReducer(false, {
  [VERIFY_EMAIL_INVALID_TOKEN]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.invalidTokenVerifyEmail,
});

export default combineReducers({
  invalidTokenVerifyEmail,
});
